import type { IProperty } from 'src/services/api/properties/types';

import propertiesApartmentBuilding from 'src/assets/img/properties/apartment_building.svg';
import propertiesCommunity from 'src/assets/img/properties/community.svg';
import propertiesCondo from 'src/assets/img/properties/condo.svg';
import propertiesHouse from 'src/assets/img/properties/house.svg';
import propertiesRoom from 'src/assets/img/properties/room.svg';
import propertiesTownhouse from 'src/assets/img/properties/townhouse.svg';

/**
 * The static type icons the table's property column renders (see ``PropertyIcon``),
 * addressable by URL for surfaces that build raw HTML, like Leaflet markers.
 */
const TYPE_ICON_URLS: Record<string, string> = {
    'Apartment Building': propertiesApartmentBuilding,
    'Apartment Floor Plan': propertiesApartmentBuilding,
    'Apartment': propertiesCondo,
    'Condo': propertiesCondo,
    'House': propertiesHouse,
    'Room': propertiesRoom,
    'Townhouse': propertiesTownhouse,
    'Community': propertiesCommunity,
};

const DEFAULT_ICON_URL = propertiesHouse;
const BUILDING_ICON_URL = TYPE_ICON_URLS['Apartment Building'];

export const typeIconUrl = (type: IProperty['type']): string => (
    TYPE_ICON_URLS[type ?? ''] ?? DEFAULT_ICON_URL
);

export const buildingIconUrl = (type: IProperty['type'] | undefined): string => (
    TYPE_ICON_URLS[type ?? 'Apartment Building'] ?? BUILDING_ICON_URL
);
